import S from 's-js';
import * as React from 'react';

import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';
import { TZUtils } from 'lib/TZUtils';
import TZDate from 'lib/TZDate';
import { tzmoment } from 'lib/tzmoment';

import { ScheduleGrid, ScheduleGridParams, SelectMode, TimelineItemType, ChangeBerthTool, EditTimeblockTool, AddShiftTool, ReservationOverlapsTool, BerthClosureOverlapsTool } from './model';
import { ScheduleGridView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';
import { NavbarTab } from '../navbar/view';

const portFilterStorageKey = 'portcall.berthtimeline.portFilter',
    capabilityFilterStorageKey = 'portcall.berthtimeline.capabilityFilter';

export const ScheduleGridRoute = (
    modelFactory : (params : ScheduleGridParams) => ScheduleGrid, 
    tzutils : TZUtils,
    appwrapper : AppWrapper, 
    request : Location
) : IRoute => {
    const model = modelFactory(inboundParams(request.params, tzutils));

    S(() => localStorage[portFilterStorageKey]       = model.PortFilter.Query());
    S(() => localStorage[capabilityFilterStorageKey] = model.CapabilityFilter.Query());

    return {
        view: 
            <AppWrapperView model={appwrapper} navbarTab={NavbarTab.Berths}>
                <ScheduleGridView model = {model} />
            </AppWrapperView>,
        reflectState: () => new Location(request.name, outboundParams(model, tzutils))
    };
};

function inboundParams(p : LocationParams, tzutils : TZUtils) : ScheduleGridParams {
    return new ScheduleGridParams(
        !!p["compact"],
          p["date"] ? tzutils.setTimezoneOffset(new TZDate(p["date"] + "T00:00:00Z"), true) : tzutils.today(),
          +(p["resid"] || 0) || null,
          +(p["uresid"] || p["buid"] || 0) || null, // Accept "buid" as a legacy synonym for "uresid" (used to call UnlistedBerthReservations "BerthUnavailables").
          +(p["bclid"] || 0) || null,
          p["port"] || localStorage[portFilterStorageKey] || '',
          p["capability"] || localStorage[capabilityFilterStorageKey] || '',
         +(p["mode"] || 0) as SelectMode || SelectMode.Details,
        !!p["backOnComplete"]
    );
}

function outboundParams(model : ScheduleGrid, tzutils : TZUtils) : LocationParams {
    let p = {} as LocationParams;

    if (model.CompactView())                                     p["compact"]    = "1";
    if (!TZDate.eq(model.DateRange.FromDate(), tzutils.today())) p["date"] = tzmoment(model.DateRange.FromDate()).format("YYYY-MM-DD");
    if (model.PortFilter.Query())                                p["port"]       = model.PortFilter.Query();
    if (model.CapabilityFilter.Query())                          p["capability"] = model.CapabilityFilter.Query();
    let tool = model.CurrentTool();
    if (tool) {
        if (tool.TimelineItem) {
            if (tool.TimelineItem.Type === TimelineItemType.BerthReservation)     p["resid"]     = tool.TimelineItem.Reservation.Id() + '';
            if (tool.TimelineItem.Type === TimelineItemType.UnlistedReservation)  p["uresid"]    = tool.TimelineItem.UnlistedReservation.Id() + '';
            if (tool.TimelineItem.Type === TimelineItemType.BerthClosure)         p["bclid"]     = tool.TimelineItem.BerthClosure.Id() + '';
        }
        const mode = tool instanceof AddShiftTool ? SelectMode.AddShift :
            tool instanceof ChangeBerthTool ? SelectMode.ChangeBerth :
            tool instanceof ReservationOverlapsTool ? SelectMode.ViewOverlaps :
            tool instanceof BerthClosureOverlapsTool ? SelectMode.ViewOverlaps :
            tool instanceof EditTimeblockTool ? SelectMode.EditTimeblock :
            undefined;
        if (mode !== undefined) p["mode"] = mode + '';
    }
    return p;
}



// WEBPACK FOOTER //
// ./apps/portcall/schedulegrid/route.tsx